require('./bootstrap');

// Import Vuex for state management
import store from './store.js';
import VeeValidate from 'vee-validate';
import Cookie from 'js-cookie';
import Vue from 'vue';

Vue.use(VeeValidate, {
    aria: true
  });
Vue.use(Cookie);

// Auto-register all the Web vue components
const files = require.context('./components/Web/', true, /\.vue$/i)


files.keys().map(key => {
    return Vue.component(_.last(key.split('/')).split('.')[0], files(key).default || files(key))
});

// Auto-register Both vue components
const both = require.context('./components/Both/', true, /\.vue$/i)

both.keys().map(key => {
    return Vue.component(_.last(key.split('/')).split('.')[0], both(key).default || both(key))
});

const app = new Vue({
    el: '#app',
	store,
	data : {
		clubTab: 'overview',
		sidebarTab: 'cricket',
		statsTab: 'open',
		partnersTab: 'official',
		resultTab: 'report',
		socialTab: 'tweets',
		cookieConsent: false,
		prevScrollpos: window.pageYOffset,
		menuHidden: false,
    },
    components: {
	},
	methods: {
		sidebarOpenCollapse(collapse, tab) {
			this.openCollapse(collapse);
			this.sidebarTab =  tab;
		},
		openCollapse(collapse) {
			$(collapse).collapse('show');
		},
		closeCollapse(collapse) {
			$(collapse).collapse('hide');
		},
        setNavSection() {
            // This method sets the side nav section so that it opens on the section of the current page.

            // first part of the path
						var section = window.location.pathname.split("/")[1];

            var cricket = new Array("match-centre", "league-tables", "cup-draws");
						var news = new Array("gallery", "social-media");

            if (cricket.indexOf(section) != -1) {
                section = 'cricket';
            } else if (news.indexOf(section) != -1) {
                section = 'news';
            }
            this.sidebarOpenCollapse('.' + section + '-links', section);
		},
		cookieConsentYes() {
			Cookie.set('consentCookie', 1, { expires: 365 });
			this.cookieConsent = false;
		},
		cookieConsentNo() {
			Cookie.set('consentCookie', 0, { expires: 365 });
			this.cookieConsent = false;
		},

		handleScroll() {
			var currentScrollPos = window.pageYOffset;
			if(screen.width > 769) {
				return;
			}
			if(screen.width < 577) {
				var top = '70px';
			} else {
				var top = '106px';
			}

			if (this.prevScrollpos > currentScrollPos || currentScrollPos < 20) {
				document.getElementById("navbar").style.top = "0";
				document.getElementById("mobile-navbar").style.top = top;
				this.menuHidden = false;
			} else {
				document.getElementById("navbar").style.top = "-" + top;
				document.getElementById("mobile-navbar").style.top = "0";
				this.menuHidden = true;
			}
			this.prevScrollpos = currentScrollPos;
		}
	},
    mounted: function () {
			this.setNavSection();
			var cookie = Cookie.get('consentCookie');
			if(cookie) {

			} else {
				this.cookieConsent = true;
			}

			window.addEventListener('scroll', this.handleScroll);
    }
});

//Js for updating the custom file input text with the name of the chosen file

'use strict';

;( function ( document, window, index )
{
	var inputs = document.querySelectorAll( '.cl-custom-file-input' );
	Array.prototype.forEach.call( inputs, function( input )
	{
		var label	 = input.nextElementSibling,
			labelVal = label.innerHTML;

		input.addEventListener( 'change', function( e )
		{
			var fileName = '';
			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				label.querySelector( 'span' ).innerHTML = fileName;
			else
				label.innerHTML = labelVal;
		});

		// Firefox bug fix
		input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
		input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
	});
}( document, window, 0 ));


// automaticaly make you tube embeds responsive

var allVideos = $("iframe[src*='//www.youtube.com']");

allVideos.each(function() {
	$(this)
		.data('aspectRatio', this.height / this.width)
    .removeAttr('height')
    .removeAttr('width');
});

$(window).resize(function() {
  allVideos.each(function() {
		var el = $(this);
		var newWidth = el.parent().width();

    el
      .width(newWidth)
      .height(newWidth * el.data('aspectRatio'));
  });
}).resize();



